import React, {useCallback, useEffect, useState} from 'react'

import {
    Box,
    Button,
    MenuItem,
    Select,
    TextField
} from '@mui/material'
import MemberService from '@/service/MemberService'
import DialogHeader from "@/view/layout/DialogHeader";
import HeaderSpacer from "@/view/layout/HeaderSpacer";

const POSITIONS = ['GK', 'CB', 'SB', 'MF', 'WF', 'CF']

export interface MemberDto {
    id?: number
    teamId?: number
    name: string
    position1: string
    position2?: string
    status?: string
}

interface Props {
    onClose: () => void
}

const MemberView = (props: Props) => {
    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])
    //const handleReturnClick = useCallback(() => {handleClose(); initData();}, [props.onClose])
    //const handleEditComplete = useCallback(() => {initData();}, [props.onClose])

    const [members, setMembers] = useState<MemberDto[]>([])
    const [selectedMember, setSelectedMember] = useState<MemberDto | null>(null)

    const [name, setName] = useState('')
    const [position1, setPosition1] = useState('')
    const [position2, setPosition2] = useState('')

    const [mode, setMode] = useState<'create' | 'delete' | 'update'>('create')

    /** 멤버 목록 조회 */
    useEffect(() => {
        loadMembers()
    }, [])

    const loadMembers = async () => {
        const list = await MemberService.getMemberList()
        setMembers(list)
    }

    /** 멤버 클릭 */
    const handleMemberClick = (m: MemberDto) => {
        setSelectedMember(m)
        setName(m.name)
        setPosition1(m.position1)
        setPosition2(m.position2 || '')
        setMode('delete')
    }

    /** 입력 변경 감지 */
    const handleNameChange = (v: string) => {
        setName(v)
        if (selectedMember && v !== selectedMember.name) {
            setMode('create')
        }
    }

    const handlePositionChange = (
        p1: string,
        p2: string
    ) => {
        setPosition1(p1)
        setPosition2(p2)

        if (
            selectedMember &&
            (p1 !== selectedMember.position1 ||
                p2 !== (selectedMember.position2 || ''))
        ) {
            setMode('update')
        }
    }

    /** 버튼 액션 */
    const handleAction = async () => {
        if (mode === 'delete' && selectedMember?.id) {
            await MemberService.deleteMember(selectedMember.id)
        }

        if (mode === 'update' && selectedMember?.id) {
            await MemberService.saveMember({
                ...selectedMember,
                name,
                position1,
                position2
            })
        }

        if (mode === 'create') {
            await MemberService.saveMember({
                name,
                position1,
                position2
            })
        }

        resetForm()
        loadMembers()
    }

    const resetForm = () => {
        setSelectedMember(null)
        setName('')
        setPosition1('')
        setPosition2('')
        setMode('create')
    }

    /** 버튼 텍스트 */
    const getButtonLabel = () => {
        if (mode === 'delete') return '삭제'
        if (mode === 'update') return '수정'
        return '등록'
    }

    return (
        <>
            <DialogHeader title='회원 관리' onClose={handleOverlayClick}/>

            {/* MEMBER LIST */}
            <div className="member-board">
                <HeaderSpacer/>
                <Box className="member-list">

                    <h4 className={'member-header'}>
                        전체 ({members.length})
                    </h4>

                    <Box className="member-scroll">
                        {members.map(m => (
                            <Box
                                key={m.id}
                                className="member-row"
                                onClick={() => handleMemberClick(m)}
                            >
                                <div className="member-line" style={{justifyContent: "center"}}>
                                    <span className="member-info">
                                        {m.name}
                                    </span>
                                    <span className="position">
                                        {m.position1}
                                        {m.position2 && `/${m.position2}`}
                                    </span>
                                </div>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* INPUT FORM */}
                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                    <TextField
                        size="small"
                        placeholder="이름"
                        value={name}
                        onChange={e =>
                            handleNameChange(e.target.value)
                        }
                    />

                    <Select
                        sx={{ height: '40px'}}
                        size="small"
                        value={position1}
                        onChange={e =>
                            handlePositionChange(
                                e.target.value,
                                position2
                            )
                        }
                    >
                        {POSITIONS.map(p => (
                            <MenuItem key={p} value={p}>
                                {p}
                            </MenuItem>
                        ))}
                    </Select>

                    <Select
                        sx={{ height: '40px'}}
                        size="small"
                        value={position2}
                        onChange={e =>
                            handlePositionChange(
                                position1,
                                e.target.value
                            )
                        }
                    >
                        <MenuItem value="">없음</MenuItem>
                        {POSITIONS.map(p => (
                            <MenuItem key={p} value={p}>
                                {p}
                            </MenuItem>
                        ))}
                    </Select>

                    <Button
                        sx={{ height: '40px'}}
                        variant="contained"
                        color={mode === 'delete' ? 'error' : 'primary'}
                        onClick={handleAction}
                    >
                        {getButtonLabel()}
                    </Button>
                </Box>
            </div>
        </>
    )
}

export default MemberView
